import React from 'react';

export default function ({skill_data, selectSkill}) {
    if (!skill_data) {
        return (
            <div className="ssp-skill ssp-section">
                <div className="ssp-skill-empty-title">
                    {`Select a Skill`}
                </div>
                <div className="center-align">
                    {`Click on any skill in the constellation to see detailed information and progress.`}
                </div>
            </div>
        );
    }

    const tier_icon_url = process.env.PUBLIC_S3_ASSETS_URL
        + `/skills-passport/tier-icon/`
        + `${skill_data.tier}.png`;

    return (
        <div className={`ssp-skill ssp-section box-shadow-${skill_data.tier}`}>
            <div className="ssp-skill-close" onClick={() => selectSkill(0)}>
                <span>&#215;</span>
            </div>

            <div className="flex-row flex-gap-10 flex-v-center">
                <div className="ssp-skill-icon flex-row flex-vh-center">
                    <img src={skill_data.image_url} />
                </div>
                <div>
                    <div className="ssp-skill-name">
                        {skill_data.name}
                    </div>
                    <div className="flex-row flex-gap-10 flex-v-center">
                        <img className="ssp-skill-tier-icon" src={tier_icon_url} />
                        <div className="ssp-skill-tier-name">{skill_data.tier}</div>
                    </div>
                </div>
            </div>

            <div className="ssp-skill-progress">
                <div className="flex-row flex-between">
                    <div>{skill_data.tier == 'master' ? 'Top tier' : 'Progress to next tier'}</div>
                    <div className={`ssp-skill-xp color-${skill_data.tier}`}>
                        {skill_data.remain_xp}{`/1000 XP`}
                    </div>
                </div>
                <div className="ssp-skill-bar">
                    <div className={`ssp-skill-bar-solid background-${skill_data.tier}`} style={{width: skill_data.xp_percentage + '%'}}></div>
                </div>
            </div>
        </div>
    );
}